"use client"

import { useState } from "react"
import { Col, Container, Row } from "reactstrap"
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs"
import PersonList from "./person-list"
import PersonDetailModal from "./person-detail-modal"
import PersonModal from "./person-modal"
import type { PersonWithAccount } from "./types"

const PersonContainer = () => {
  const [modalOpen, setModalOpen] = useState(false)
  const [detailModalOpen, setDetailModalOpen] = useState(false)
  const [selectedItem, setSelectedItem] = useState<PersonWithAccount | null>(null)
  const [refreshTrigger, setRefreshTrigger] = useState(false)

  const handleOpenAdd = () => {
    setSelectedItem(null)
    setModalOpen(true)
  }

  const handleOpenEdit = (item: PersonWithAccount) => {
    setSelectedItem(item)
    setModalOpen(true)
  }

  const handleOpenView = (item: PersonWithAccount) => {
    setSelectedItem(item)
    setDetailModalOpen(true)
  }

  const handleSuccess = () => {
    setModalOpen(false)
    setRefreshTrigger((prev) => !prev)
  }

  return (
    <>
      <Breadcrumbs mainTitle="User Management" parent="Users" />
      <Container fluid>
        <Row>
          <Col md="12">
            <PersonList
              onAdd={handleOpenAdd}
              onEdit={handleOpenEdit}
              onView={handleOpenView}
              refreshTrigger={refreshTrigger}
            />
          </Col>
        </Row>

        <PersonModal
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
          onSuccess={handleSuccess}
          initialData={selectedItem}
        />

        <PersonDetailModal isOpen={detailModalOpen} onClose={() => setDetailModalOpen(false)} person={selectedItem} />
      </Container>
    </>
  )
}

export default PersonContainer
